import React from 'react';
import {BiSolidDownArrow, BiSolidUpArrow} from "react-icons/bi"

type Props = {
    onClick?: () => void,
    children?: React.ReactNode,
    type?: 'button' | 'submit',
    className?: string,
    isOpen: boolean,
    title: string,
}

const ButtonAccordionHandler = ({isOpen, children, type = 'button', className = '', onClick, title}: Props) => {

    const handleClick = () => {
        onClick && onClick();
    }

    return (
        <button
            type={type}
            className={`flex bg-mcia_salmon text-white uppercase font-medium py-1.5 px-4 pb-2 rounded shadow-xl ${className}`}
            onClick={handleClick}
        >
            {isOpen ? `close ${title}` : `open ${title}`}
            <div className="ml-4 mt-1.5">
                {isOpen ? <BiSolidDownArrow/> : <BiSolidUpArrow/>}
            </div>
        </button>
    );
};

export default ButtonAccordionHandler;